import "./ExploreContainer.css";

const ExploreContainer: React.FC = ({ children }) => {
  return <div>{children}</div>
};

export default ExploreContainer;
